import { images } from "../assets/img";

export const NAIL_BRANCHES = [
  {
    id: "cheshunt",
    name: "Kevin Nails - Turners Hill",
    ggMapUrl: "https://maps.app.goo.gl/DBKNaWcqMzRtQRsm9",
    address: "19 Turners Hill, Cheshunt, Waltham Cross EN8 8NJ, UK",
    ggMapIframeUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1118.4777549976275!2d-0.035175697549535735!3d51.699941297519274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48762039ef0762ef%3A0xa54797726fa07a15!2s19%20Turners%20Hill%2C%20Cheshunt%2C%20Waltham%20Cross%20EN8%208NJ%2C%20UK!5e1!3m2!1sen!2s!4v1734085130552!5m2!1sen!2s",
    email: "kevinnails2024@gmail.com",
    tel: "+441992937288",
    phone: "+44 199 293 7288",
    facebookId: "411793872023888",
    instagramName: "kevin_nails_2024",
    bookingUrl: "https://kevinnails.setmore.com/",
    openingTime: {
      openTime: { weekdays: "MONDAY - SATURDAY", time: "09:30 - 18:30" },
      closeTime: { weekdays: "SUNDAY & Bank Holiday", time: "Closed" },
    },
    headerWelcomeMsg:"Welcome to Kevin Nails, your trusted nail salon $lineBreak at 19 Turners Hills Cheshunt EN8 8NJ. We pride ourselves on delivering exceptional nail care, offering everything from chic manicures to artistic nail designs.\n\nVisit us today, and let your nails dazzle!",
 primaryBannerTitle:"YOUR NAILS\n       YOUR STYLE",
    primaryBannerMsg:            "A talented team of Nail Specialists is here to deliver a top-notch treatment experience tailored to you.\nWith extensive training and a sharp focus on detail, every element of your nail care will be executed with expertise and care.\n\nFrom helping you select the ideal shade to providing personalized design guidance,\nwe're committed to making your visit nothing short of exceptional."

  },
  {
    id: "camden",
    name: "Kevin Nails - Camden Town",
    ggMapUrl: "https://maps.app.goo.gl/1N8xJr3cFqvU2PjF8",
    address: "42 Camden High Street, London NW1 0JH, UK",
    ggMapIframeUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.053497514362!2d-0.14063428422967342!3d51.538123579641025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ace3fefb2df%3A0x2d2346f4ef90ec3e!2s42%20Camden%20High%20St%2C%20London%20NW1%200JH%2C%20UK!5e0!3m2!1sen!2suk!4v1735200000000!5m2!1sen!2suk",
    email: "camden@kevinnails.co.uk",
    tel: "+442038765432",
    phone: "+44 203 876 5432",
    facebookId: "657483920184739",
    instagramName: "kevin_nails_camden",
    bookingUrl: "https://kevinnailscamden.setmore.com/",
    openingTime: {
      openTime: { weekdays: "MONDAY - SATURDAY", time: "10:00 - 19:00" },
      closeTime: { weekdays: "SUNDAY", time: "11:00 - 16:00" },
    },
    headerWelcomeMsg:"Welcome to Kevin Nails, your trusted nail salon $lineBreak at CAMDENNNN. We pride ourselves on delivering exceptional nail care, offering everything from chic manicures to artistic nail designs.\n\nVisit us today, and let your nails dazzle!",
    primaryBannerTitle:"WHERE STYLE\n       MEETS SERENITY",
    primaryBannerMsg:"A skilled team of nail artists is dedicated to providing an experience that blends precision, care, and creativity.\nFrom detailed treatments to custom designs, every step is thoughtfully executed with your style in mind.\n\nWhether you're selecting the perfect shade or exploring something new,\nweÃ¢â‚¬â„¢re here to make your nail experience feel truly exceptional."
  }
];

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/DBKNaWcqMzRtQRsm9",
  address: "19 Turners Hill, Cheshunt, Waltham Cross EN8 8NJ, UK",
  ggMapIframeUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1118.4777549976275!2d-0.035175697549535735!3d51.699941297519274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48762039ef0762ef%3A0xa54797726fa07a15!2s19%20Turners%20Hill%2C%20Cheshunt%2C%20Waltham%20Cross%20EN8%208NJ%2C%20UK!5e1!3m2!1sen!2s!4v1734085130552!5m2!1sen!2s",
  email: "kevinnails2024@gmail.com",
  tel: "+441992937288",
  phone: "+44 199 293 7288",
  facebookId: "411793872023888",
  instagramName: "kevin_nails_2024",
  name: "Kevin Nails",
  bookingUrl: "https://kevinnails.setmore.com/",
  openingTime: {
    openTime: { weekdays: "MONDAY - SATURDAY", time: "09:30 - 18:30" },
    closeTime: { weekdays: "SUNDAY & Bank Holiday", time: "Closed" },
  },
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`;
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`;

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const SERVICES = [
  {
    name: "Manicures",
    description:
      "Experience a manicure that focuses on precision and care, using premium products to enhance the natural beauty of your nails. Our expert technicians ensure that your nails are treated with the utmost attention and ready to impress.",

    image: images.nailService,
  },
  {
    name: "Pedicures",
    description:
      "Indulge in a pedicure that shapes, smooths, and cares for your nails and toes. Enjoy exfoliation with a refreshing cucumber or peppermint mask, followed by a soothing cream application, and finish with the perfect color of your choice.",
    image: images.nailService2,
  },
  {
    name: "Our Technicians",
    description:
      "Our highly qualified team of nail technicians will take care your nails the ins and outs during your experiences at our nails bar. We always welcome you with a warm smile and make you feel at home.",
    image: images.nailService3,
  },
  {
    name: "Nails Art",
    description:
      "From classic to outstanding, our talented technicians can advise you the bespoke nail art of your imagine. Come here and enjoy your amazing nails art at our local shop",
    image: images.nailService4,
  },
];

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Emily Harper",
    feedback:
      "Ã¢â‚¬Å“The service was fantastic, and the staff were so professional and welcoming. I loved how my nails turned outÃ¢â‚¬â€just perfect!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/sU1i6Sk.png",
  },
  {
    name: "Sophia Brooks",
    feedback:
      "Ã¢â‚¬Å“Such a relaxing experience! The team really paid attention to every detail, and I left feeling so happy with the results.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/Lq7YQ1o.png",
  },
  {
    name: "Chloe Bennett",
    feedback:
      "Ã¢â‚¬Å“Professional, clean, and efficient. IÃ¢â‚¬â„¢m so pleased with the results! Would definitely recommend this place to others.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/HDBW1Xg.png",
  },
  {
    name: "Olivia Carter",
    feedback:
      "Ã¢â‚¬Å“A wonderful experience! The staff were attentive, and the results exceeded my expectations. IÃ¢â‚¬â„¢ll definitely be back.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/RsFFmiS.png",
  },
  {
    name: "Hannah Collins",
    feedback:
      "Ã¢â‚¬Å“Great value for the quality of work! The attention to detail is impressive, and the results were flawless. Highly recommend.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/Ds2X7zK.png",
  },
  {
    name: "Grace Taylor",
    feedback:
      "Ã¢â‚¬Å“I had an amazing experience! The team made sure I was comfortable and satisfied every step of the way. My nails look beautiful.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Madison Green",
    feedback:
      "Ã¢â‚¬Å“Top-notch service from start to finish! The results were stunning, and I loved the friendly atmosphere. IÃ¢â‚¬â„¢ll be recommending it to everyone.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Ava Mitchell",
    feedback:
      "Ã¢â‚¬Å“The team did a fantastic job! TheyÃ¢â‚¬â„¢re skilled, attentive, and ensured everything was perfect. My nails look amazing!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
];

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  {
    name: "Loyalty",
    navigationKey: "https://loyalty.solcomarketing.com/kevin-nails-cheshunt",
  },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
